export default __webpack_public_path__ + "static/media/ta.b86f9be9.svg";